import React from 'react';
import AppHistory from './components';
import Layout from '../../layouts/index';

const History = () => {
    return (
        <Layout>
            <AppHistory />
        </Layout>
    );
};

export default History;
